// frontend/src/components/GongsilView.jsx
//
// [GONGSIL_MENU_V1] 공실클럽 수집자료 — 앱 내부 페이지
//
// 왜 iframe 인가:
//   조회화면(필터·정렬·CSV·상세패널·매물장 등록)은 백엔드가 통째로 그리는 HTML 입니다.
//   (backend/routes/gongsilImport.js 의 VIEW_HTML)
//   이걸 React 로 다시 만들면 800줄을 두 벌 관리하게 되고,
//   한쪽만 고치는 실수가 생깁니다. 그래서 화면은 그대로 두고 '앱 안에 끼워' 보여줍니다.
//
//   · 같은 도메인이라 localStorage 를 공유합니다 → 인증키를 한 번만 입력하면 계속 유지
//   · 백엔드가 frame-ancestors 'self' 로 응답하므로 같은 도메인에서만 끼울 수 있습니다
//     (외부 사이트가 우리 화면을 몰래 감싸는 것 방지)
//
// 연관 파일:
//   - components/Header.jsx  : "🏘️ 수집데이터" 메뉴가 /gongsil 로 이동
//   - App.js (라우터)        : <Route path="/gongsil" element={<GongsilView />} />
//   - backend/routes/gongsilImport.js : /api/import/gongsil/view 를 그리는 곳

import React from "react";

export default function GongsilView() {
  return (
    <div
      style={{
        // 헤더(로고행 60px + 메뉴행 약 40px)를 뺀 나머지를 꽉 채웁니다.
        // 화면이 좁아 메뉴가 두 줄이 되면 조금 잘릴 수 있어 minHeight 를 같이 둡니다.
        height: "calc(100vh - 100px)",
        minHeight: "420px",
        width: "100%",
        background: "#f6f7f9",
      }}
    >
      <iframe
        src="/api/import/gongsil/view"
        title="공실클럽 수집자료"
        style={{
          width: "100%",
          height: "100%",
          border: 0,
          display: "block",
        }}
        // sandbox 는 일부러 쓰지 않습니다.
        //   같은 도메인의 우리 화면이라 제한할 이유가 없고,
        //   sandbox 를 걸면 CSV 내려받기와 인증키 저장(localStorage)이 막힐 수 있습니다.
        //   외부에서 우리 화면을 감싸는 것은 백엔드의 frame-ancestors 'self' 가 막습니다.
      />
    </div>
  );
}
